/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne Swagger
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 4bcfc99b (Thu Mar  7 14:01:07 UTC 2024)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  CashAmount,
  CashAmountFromJSON,
  CashAmountToJSON,
  TuitionInvoiceDiscountCode,
  TuitionInvoiceDiscountCodeFromJSON,
  TuitionInvoiceDiscountCodeToJSON,
} from './'

/**
 *
 * @export
 * @interface Discount
 */
export interface Discount {
  /**
   * The unique identifier of a manual director discount made towards an enrollment.
   * @type {number}
   * @memberof Discount
   */
  paymentKey?: number
  /**
   * An explanation for why a discount was applied.
   * @type {string}
   * @memberof Discount
   */
  desc: string
  /**
   *
   * @type {CashAmount}
   * @memberof Discount
   */
  amount: CashAmount
  /**
   *
   * @type {TuitionInvoiceDiscountCode}
   * @memberof Discount
   */
  code: TuitionInvoiceDiscountCode
}

export function DiscountFromJSON(json: any): Discount {
  return DiscountFromJSONTyped(json, false)
}

export function DiscountFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Discount {
  if (json === undefined || json === null) {
    return json
  }
  return {
    paymentKey: !exists(json, 'paymentKey') ? undefined : json['paymentKey'],
    desc: json['desc'],
    amount: CashAmountFromJSON(json['amount']),
    code: TuitionInvoiceDiscountCodeFromJSON(json['code']),
  }
}

export function DiscountToJSON(value?: Discount | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    paymentKey: value.paymentKey,
    desc: value.desc,
    amount: CashAmountToJSON(value.amount),
    code: TuitionInvoiceDiscountCodeToJSON(value.code),
  }
}
